import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {Usuario} from '../../../../../@cdk/models';
import {LoginService} from '../../../../../app/main/auth/login/login.service';

@Component({
  selector: 'cdk-barra-pesquisa-consultivo',
  templateUrl: './barra-pesquisa.component.html',
  styleUrls: ['./barra-pesquisa.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BarraPesquisaComponent {

    searchQuery = '';
    content = new FormControl('');
    usuario: Usuario;

    constructor(
        private _router: Router,
        private _loginService: LoginService,
        private _cd: ChangeDetectorRef
    ) {
    }

    onSearchConsultiva(event: KeyboardEvent) {
        event.preventDefault();
        const query = this.searchQuery || this.content?.value;
        if (query) {
            this._router.navigate(['/apps/pesquisa/consultivo'], { queryParams: { q: query } }).then();
        }
    }
}
